import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class Menu 
{
  
  
  toggled = false;

  menus = [
    
    {
      title: 'Mon compte',
      type: 'header',
      permission:'for_all'
    },
    {
      title: 'Profil',
      Url:'/account/profile',
      icon: 'fa fa-user',
      active: '',
      permission:'for_all',
      type: 'simple'
    },
    {
      title: 'Signature',
      Url:'/account/signature',
      icon: 'fa fa-pencil',
      active: '',
      permission:'for_all',
      type: 'simple'
    },
    {
      title: 'Absence',
      Url:'/account/conges',
      icon: 'fa fa-calendar',
      active: '',
      permission:'for_all',
      type: 'simple'
    },
    {
      title: 'Mot de passe',
      Url:'/account/change-password',
      icon: 'fa fa-shield',
      active: '',
      permission:'for_all',
      type: 'simple'
    },
    

  ];




  constructor() { }

  toggle() {
    this.toggled = ! this.toggled;
  }

  getSidebarState() {
    return this.toggled;
  }

  setSidebarState(state: boolean) {
    this.toggled = state;
  }

  getMenuList() {
    return this.menus;
  }



}